<template>
  <div class="footer">
    <a class="footer-link" @click="openPrivacyPolicy">{{ privacyText }}</a>
    <span>{{ version }} | {{ copyRightText }}</span>
  </div>
</template>
<script src="./footer.ts" lang="ts" />
<style src="./footer.scss" lang="scss" scoped />
